<template>
  <div class="main-container" :class="{ 'open-fade': isOpen }" ref="modalContainer" @click="handleClickOutside($event)">
    <div class="modal" :class="{ 'open-scale': isOpen }">
      <div class="close-button noselect" @click="cancel">
        <span>&#128473;</span>
      </div>
      <h2>{{ text }}</h2>
      <p v-html="paragraph"></p>
      <div class="inputs">
        <div v-if="fileUpload">
          <label for="files">{{ fileUpload }}</label>
          <input type="file" name="files" @change="prepareFiles()" ref="files" multiple />
        </div>
        <input :type="type ? type : 'text'" v-if="input" :placeholder="input" v-model="inputValue"
          :maxlength="maxlength" @keydown.enter="submit" />
        <div v-if="dropdown">
          <v-select :label="$t('globalsShared.dialog.select')" v-model="dropdownSelectedVal" item-text="name" item-value="id" :items="dropdown.options" :placeholder="dropdown.placeholder" ></v-select>
        </div>
        <input v-if="inputs" v-for="input in inputs" :key="input.key" :placeholder="input.placeholder"
          v-model="input.value" />
      </div>
      <div v-if="list.length > 0" class="list">
        <table>
          <tr>
            <td style="text-align: start; padding-bottom: 8px;" colspan="3">{{ $t("globalsShared.dialog.availableSoundFiles") }}</td>
          </tr>
          <tr>
            <td colspan="3">
              <hr>
            </td>
          </tr>
          <tbody v-for="(item, index) in list" :key="`${index}-file-${item.item}`">
            <tr>
              <td><b>{{ index + 1 }}</b></td>
              <td>{{ item.item }}</td>
              <td style="display: flex; flex-direction: row; gap: 12px; justify-content: flex-end;">
                <a v-if="!item.loading && !item.urlObject"
                  @click="!item.loading && downloadSound(item.item, index, true);" style="cursor: pointer;">{{ $t("globalsShared.dialog.playAudio") }}</a>
                <a v-if="!item.loading" @click="!item.loading && downloadSound(item.item, index);"
                  style="cursor: pointer;">{{ $t("globalsShared.dialog.download") }}</a>
                <label v-if="item.loading">{{ $t("globalsShared.dialog.loading") }}</label>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <audio style="width: 100%;" v-if="!item.loading && item.urlObject" controls>
                  <source :src="item.urlObject">
                </audio>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <hr>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="buttons-container">
        <button @click="cancel" v-if="!hideCancel" outline>{{ $t("globalsShared.dialog.cancel") }}</button>
        <button @click="submit" :disabled="loading">
          <span :class="{ 'opacity-0': loading }">{{ $t("globalsShared.dialog.ok") }}</span>
          <div class="spring-spinner" v-if="loading">
            <div class="spring-spinner-part top">
              <div class="spring-spinner-rotator"></div>
            </div>
            <div class="spring-spinner-part bottom">
              <div class="spring-spinner-rotator"></div>
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DIALOVA_DIALOG_COMPONENT",
  data() {
    return {
      isOpen: false,
      resolvePromise: null,
      rejectPromise: null,
      text: "",
      paragraph: "",
      type: "text",
      input: null,
      inputValue: "",
      // Optional cap on the single text input (null = no limit).
      maxlength: null,
      loader: false,
      loading: false,
      type: "",
      list: [],
      hideCancel: false,
      inputs: [
        {
          placeholder: "",
          value: "",
          key: "",
        },
      ],
      additionalData: {},
      fileUpload: "",
      dropdown: null,
      dropdownSelectedVal: null,
      files: null,
      filesLoader: []
    };
  },
  methods: {
    handleClickOutside(event) {
      if (this.$refs.modalContainer == event.target) {
        this.cancel();
      }
    },
    openDialog(options) {
      return new Promise((resolve, reject) => {
        this.isOpen = true;
        this.text = options.title;
        this.paragraph = options.paragraph;
        this.inputs = null;
        this.input = null;
        if (!Array.isArray(options.input)) this.input = options.input || null;
        else this.inputs = options.input;
        this.inputValue = options.inputValue;
        this.maxlength = options.maxlength || null;
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
        this.loader = options.loader || false;
        this.loading = false;
        this.type = options.type || "";
        this.fileUpload = options.fileUpload || "";
        this.dropdown = options.dropdown || null;
        this.hideCancel = options.hideCancel || false;
        if (options.list) {
          this.list = options.list.map((item) => {
            return {
              item: item,
              loading: false,
              urlObject: ''
            }
          });
        } else {
          this.list = [];
        }
        this.additionalData = options.additionalData || {};
      });
    },
    submit() {
      let preparedInputs = null;
      if (this.inputs) {
        preparedInputs = {};
        this.inputs.forEach((item) => {
          preparedInputs[item.key] = item.value;
        });
      }
      if (!this.loader) {
        this.resolvePromise({
          value: this.inputs ? preparedInputs : this.inputValue || null,
          files: this.files || null,
          dropdown: this.dropdownSelectedVal || null
        });
        this.close();
      } else {
        this.resolvePromise({
          close: this.close,
          value: this.inputs ? preparedInputs : this.inputValue || null,
          files: this.files || null,
          dropdown: this.dropdownSelectedVal || null
        });
        this.loading = true;
      }
    },
    close() {
      if (this.list) {
        this.list.forEach((item) => {
          if (item.urlObject)
            URL.revokeObjectURL(item.urlObject)
        })
      }
      if (this.fileUpload) {
        this.$refs.files.value = null;
      }
      this.dropdownSelectedVal = null;
      this.loading = false;
      this.isOpen = false;
    },
    cancel() {
      this.rejectPromise();
      this.close();
    },
    downloadSound(name, index, showPlayer) {
      this.list[index].loading = true;
      axios({
        url: `complaint/${this.additionalData.id}/audio/${name}`,
        method: "GET",
        responseType: "blob",
      }).then((res) => {

        this.list[index].loading = false;
        const href = URL.createObjectURL(res.data);

        if (!showPlayer) {
          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.innerHTML = " download";
          link.setAttribute("download", name); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        } else {
          this.list[index].urlObject = href;
        }
      }).finally(() => {
        this.filesLoader[index] = false;
      });
    },
    prepareFiles() {
      this.files = this.$refs.files.files;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  font-family: Poppins;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

@keyframes openScale {
  from {
    transform: scale(0.8);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.opacity-0 {
  opacity: 0 !important;
}

.open-scale {
  transform: scale(1) !important;
  opacity: 1 !important;
  animation: 0.2s openScale;
}

.open-fade {
  opacity: 1 !important;
  pointer-events: all !important;
}

.main-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  background-color: rgba(#222, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: 0.4s;
  pointer-events: none;
  z-index: 250;
  backdrop-filter: blur(2px);

  .modal {
    padding: 36px 28px;
    background: white;
    width: max-content;
    min-width: 250px;
    max-width: 580px;
    height: fit-content;
    float: inline-start;
    border-radius: 8px;
    margin-bottom: 4vh;
    position: relative;
    transform: scale(0.8);
    opacity: 0;
    transition: 0.2s;

    .close-button {
      inset-inline-end: 0;
      position: absolute;
      bottom: calc(100% + 12px);
      background: rgba(#fff, 0.6);
      border: 1px solid #fff;
      width: 26px;
      height: 26px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      cursor: pointer;
      color: #84969e;

      span {
        margin-bottom: 1px;
        font-size: 12px;
      }
    }

    h2 {
      width: 100%;
      max-width: 100%;
      word-break: break-word;
      float: inline-start;
      color: #202731;
      max-height: 400px;
      overflow-y: auto;
      font-size: 16pt;
      padding: 0;
      margin: 0;
      font-weight: 500;

      &::-webkit-scrollbar {
        width: 0.2em;
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #c1c5d8;
        border-radius: 9999px;
      }
    }

    p {
      margin-top: 8px;
      float: inline-start;
      color: #84969e;
      font-size: 12pt;

      b {
        color: #202731 !important;
        font-weight: 500;
      }
    }

    .inputs {
      width: 100%;
      float: inline-start;
      margin-top: 12px;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .list {
      width: 100%;
      float: inline-start;
      margin-top: 12px;

      table {
        width: 100%;
        float: inline-start;

        tr,
        td {
          padding: 2px;
        }

        td:last-child {
          text-align: end;
        }
      }
    }

    input {
      width: 100%;
      float: inline-start;
      padding: 16px;
      background: #f7f8fa;
      border: 1px solid #c1c5d8;
      border-radius: 8px;
      transition: 0.2s;

      &:focus {
        outline: none;
        border: 1px solid #ff9fa8;
        box-shadow: 0px 0px 2px #ff9fa8;
      }

      &[type=file] {
        width: 100%;
        float: inline-start;
        padding: 2px;
        background: #f7f8fa;
        border: 1px solid #c1c5d8;
        border-radius: 8px;
        transition: 0.2s;
      }
    }

    .buttons-container {
      width: 100%;
      height: auto;
      margin-top: 22px;
      float: inline-start;
      display: flex;
      justify-content: flex-end;
      gap: 8px;

      button {
        float: inline-end;
        padding: 10px 28px;
        width: auto;
        background: #e10015;
        color: white;
        border: none;
        border-radius: 4px;
        font-weight: 400;
        cursor: pointer;
        transition: 0.1s;
        max-height: 43px;
        position: relative;

        &[outline] {
          background: #fff;
          border: 1px solid #e10015;
          color: #e10015;
        }

        &:hover {
          box-shadow: 0px 0px 6px rgba(#202731, 0.12);
        }
      }
    }
  }
}

/* Spinner */

.spring-spinner,
.spring-spinner * {
  box-sizing: border-box;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
}

.spring-spinner {
  height: 100%;
  max-height: 18px;
  width: auto;
  max-width: 18px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
}

.spring-spinner .spring-spinner-part {
  overflow: hidden;
  max-height: 9px;
  height: 100%;
  width: auto;
  max-width: 18px;
}

.spring-spinner .spring-spinner-part.bottom {
  transform: rotate(180deg) scale(-1, 1);
}

.spring-spinner .spring-spinner-rotator {
  width: 18px;
  height: 18px;
  border: 2.5px solid transparent;
  border-right-color: white;
  border-top-color: #d9d9d9;
  border-radius: 50%;
  box-sizing: border-box;
  animation: spring-spinner-animation 3s ease-in-out infinite;
  transform: rotate(-200deg);
}

@keyframes spring-spinner-animation {
  50% {
    transform: rotate(115deg);
  }
}
</style>
